<template>
  <b-row>
    <b-col cols="4" style="text-align: left;">
      <h3>Editar Datos:</h3>
      <lockscreen v-if="loading" style="text-align:center; vertical-align:middle; padding-top: 50px; color: white;">
        <div>Espere un momento ...</div>
      </lockscreen>
      <b-form @submit="onSubmit">

        <b-form-group id="input-group-3" label="" label-for="input-3" v-if="price">
          <b-row>
            <b-col cols="12"><h2>Precio $ {{price}} MXN</h2></b-col>
            <b-col cols="12"><h4>ZONA {{zoneName}}</h4>{{kms}} Kms {{minutes}} Minutos</b-col>
          </b-row>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Lugar de Recolección"
          label-for="input-1"
          :description="form.originAddress"
        >
        <b-form-input
            id="autocomplete"
            v-model="form.origin"
            type="text"
            required
            placeholder="Bellas Artes"
          ></b-form-input>
        </b-form-group>


        <b-form-group id="input-group-3" label="Destino:" label-for="input-3">
          <b-form-select
            id="input-3"
            v-model="form.destination"
            :options="destinations"
            v-on:change="estimation"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-3" label="Servicio:" label-for="input-3" v-if="form.company !== 'LZpb5aKEpp'">
          <b-form-select
            id="input-3"
            v-model="form.service"
            :options="services"
            v-on:change="estimation"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-2" label="Nombre Pasajero" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            required
            autocomplete="off"
            placeholder="Ingrese Nombre"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-phone"
          label="Teléfono Pasajero"
          label-for="input-phone"
          autocomplete="off"
          description="Seleccione el país del teléfono"
        >
        <vue-tel-input v-model="form.phone"  ref="telInput"></vue-tel-input>

        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Correo Electrónico"
          label-for="input-1"
          autocomplete="off"
          description="Necesitamos su dirección de correo electrónico para notificarle"
        >
        <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Ingrese Correo Electrónico"
          ></b-form-input>
        </b-form-group>


        <b-form-group id="input-group-3" label="Fecha y Hora De Recolección" label-for="input-3">
          <datetime v-model="form.date" type="datetime" :min-datetime="dateMin"	></datetime>
        </b-form-group>

        <b-form-group
          id="input-note"
          label="Notas"
          label-for="input-note"
        >
        <b-form-textarea
            id="note"
            v-model="form.note"
            type="text"
            required
            placeholder="Notas"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group id="input-group-3" label="Servicio:" label-for="input-3" v-if="form.company !== 'LZpb5aKEpp'">
          <b-form-select
            id="input-3"
            v-model="form.method"
            :options="methods"
            required
          ></b-form-select>
        </b-form-group>


        <!--
        <b-form-group id="input-group-3" label="" label-for="input-3" v-if="companyName">
          <b-row>
            <b-col cols="5"><img :src="companyImg" height="50"/></b-col>
          </b-row>
        </b-form-group>
        -->

        <!--
        <b-form-group id="input-group-4">
          <b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
            <b-form-checkbox value="me">Check me out</b-form-checkbox>
            <b-form-checkbox value="that">Check that out</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        -->

        <b-button type="submit" variant="primary">Enviar</b-button>
        <!-- <b-button type="reset" variant="danger" ref="btnReset">Reset</b-button> -->
      </b-form>
      
      <!--
      <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
      
      Sesión Expira: {{expiresAt}}
      -->
    </b-col>
    <b-col cols="8">
      <google-map :origin="originPlace"></google-map>

    </b-col>
  </b-row>
</template>

<script>

  import Vue from 'vue'
  import Parse from 'parse'
  import VueTelInput from 'vue-tel-input'
  import Datetime from 'vue-datetime'

  import GoogleMap from './GoogleMap'
  import * as GoogleMapsLoader from 'google-maps'


  import lockscreen from 'vue-lockscreen'
  Vue.component('lockscreen', lockscreen)

  // You need a specific loader for CSS files
  import 'vue-datetime/dist/vue-datetime.css'
   
  Vue.use(Datetime)

  Vue.use(VueTelInput, {placeholder: 'Ingrese número telefónico', enabledCountryCode: true, preferredCountries: ['MX', 'US', 'CA', 'ES', 'GB', 'FR', 'DE', 'NL' , 'BR', 'CO']})
  // var geodist = require('geodist')

  Vue.use(Parse)
  Parse.initialize("bBzZ7wYYGIpQkPPB");
  Parse.serverURL = 'https://aircab.herokuapp.com/parse'
  // Parse.initialize("BewIZ9dlh4gNBStm")
  // Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'
  var moment = require('moment-timezone')
  var timezone = 'America/Mexico_City'

  export default {
    props: ['queueId'],
    components: {
      GoogleMap
    },
    data() {
      return {
        loading: false,
        autocomplete: null,
        originPlace: null,
        form: {
          date: null,
          email: '',
          name: '',
          phone: '',
          origin: '',
          originPosition: null,
          originAddress: null,
          destination: null,
          company: null,
          service: null,
          countryCode: null,
          note: '',
          method: null,
        },
        methods: [{text: 'Efectivo', value: 0 }, {text: 'Tarjeta', value: 1 }],
        destinations: [{ text: 'Seleccione un destino', value: null }, 'TERMINAL 1', 'TERMINAL 2'],
        companies: [{ text: 'Seleccione una compañía', value: null }, { text: 'YELLOWCAB', value: 'XmyHSNAuOu' }, { text: 'PORTOTAXI', value: 'LZpb5aKEpp' }],
        services: [{ text: 'Seleccione un servicio', value: null }, { text: 'SEDAN', value: '81xnODWceY' }, { text: 'EJECUTIVO', value: 'LSwR1ptmwZ' }],
        show: true,
        expiresAt: null,
        currentSession: null,
        currentUser: null,
        dateMin: null,
        company: null,
        companyName: null,
        companyImg: null,
        companyClient: null,
        response: null,
        price: null,
        minutes: null,
        kms: null,
        zoneName: null,
        zonePrice: null,
        travel: null
      }
    },
    async created () {
    },
    async mounted() {
      let vue = this
      vue.loading = false
      GoogleMapsLoader.KEY = 'AIzaSyCFYbCzul-yEAWWod4G6SJ5qx4lrKXeAnc'
      GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
      GoogleMapsLoader.LANGUAGE = 'es'
      GoogleMapsLoader.REGION = 'MX'
      GoogleMapsLoader.load((google) => {
        /* eslint-disable no-new */
        /*new google.maps.Map(this.$el, {
          center: new google.maps.LatLng(19.4419179,-99.1634196),
          zoom: 12,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        */

        vue.autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */ (
          document.getElementById('autocomplete')), {
          //types: ['(cities)'],
          componentRestrictions: {country: 'mx'}
        })

        vue.autocomplete.addListener('place_changed', vue.onPlaceChanged);

      })

      let now = new Date()
      let dateLimit = new Date(now.getTime() + 4 * 60 * 60 * 1000)
      let m = new moment.tz(dateLimit, timezone)
      console.log(m, m.format())
      this.dateMin = m.format()
      try {
        console.log('created')
        this.currentUser = Parse.User.current()
        this.currentSession = await Parse.Session.current()
        console.log('currentUser',this.currentUser, this.currentUser._getId(), this.currentSession)
        this.expiresAt = moment(this.currentSession.get('expiresAt'), timezone).format()
        await this.currentUser.fetch()
      } catch (error) {
        console.log('error login', error)
        this.$router.push('/login');
        return false
      }
      if (!this.currentUser) {
        this.$router.replace('/login')
      } else if (!this.currentUser.get('isSeller')) {
        Parse.User.logOut().then(() => {
          this.$router.replace('/login');
        })
      } else {
        console.log('usuario correcto')
        try {
          let Company = Parse.Object.extend('Company')
          this.company = new Company()
          this.company.id = this.currentUser.get('sellerCompany').id
          await this.company.fetch()
          this.companyName = this.company.get('name')
          this.companyImg = this.company.get('logo').url()
          this.companyClient = this.company.get('client')
          console.log('company', this.company)

          let ids = this.$el.baseURI.split('/')
          this.travel = await Parse.Cloud.run('getTravelByIdCallCenter', { travelId: ids[ids.length - 1] })
          
          this.price = this.travel.get('estimatedCost')
          this.minutes = Math.ceil(this.travel.get('estimatedSec') / 60)
          this.kms = this.travel.get('estimatedKms')
          this.zoneName = this.travel.get('zoneName')
          this.form.method = this.travel.get('paymentMethod')
          this.form.originAddress = this.travel.get('originAddress')
          this.form.origin = this.travel.get('originAddress')
          this.form.originPosition = this.travel.get('position')
          let myPosition = {lat: this.travel.get('position').latitude, lng: this.travel.get('position').longitude}
          console.log('latlin', myPosition)
          this.originPlace = new google.maps.Marker({
              position: myPosition,
              title:"Origen"
          })

          this.form.phone = this.travel.get('clientPhone')
          this.form.name = this.travel.get('clientFirstName')
          this.form.email = this.travel.get('clientEmail')
          this.form.note = this.travel.get('note')
          this.form.date = new moment.tz(this.travel.get('scheludedAt'), timezone).format()

          if (this.travel.get('destinyName') === 'TERMINAL 1' || this.travel.get('destinyName') === 'TERMINAL 2') {
            this.form.destination = this.travel.get('destinyName')
          }

          this.form.service = this.travel.get('service').id
        } catch (error) {
          console.log('error', error)
        }
      }
    },
    methods: {
      onPlaceChanged() {
        let vue = this
        vue.originPlace = vue.autocomplete.getPlace()
        // console.log('originPlace', vue.originPlace)
        vue.form.originAddress = vue.originPlace.formatted_address
        vue.form.origin = vue.originPlace.name
        vue.form.originPosition = new Parse.GeoPoint({latitude: vue.originPlace.geometry.location.lat(), longitude: vue.originPlace.geometry.location.lng()})
        vue.estimation()
        /*
        if (place.geometry) {
          map.panTo(place.geometry.location);
          map.setZoom(15);
          search();
        } else {
          document.getElementById('autocomplete').placeholder = 'Enter a city';
        }
        */
      },
      async estimation() {

        let vue = this

        console.log('estimation', vue.form.origin, vue.form.destination, vue.form.service)
        if (!vue.form.origin || !vue.form.destination || !vue.form.service) {
          return false
        }

        vue.loading = true
        let origin_lat = this.form.originPosition.latitude
        let origin_lon = this.form.originPosition.longitude
        

        let date = new Date(vue.form.date)
        let phoneInt = vue.$refs.telInput.phoneObject.number.international


        // alert(JSON.stringify(this.form))
       
        let company = this.company


        if (vue.form.company === 'LZpb5aKEpp') {
          vue.form.service = 'LSwR1ptmwZ'
        }
        
        let Service = Parse.Object.extend('Service')
        let service = new Service()
        service.id = this.form.service
        await service.fetch()

        let user = new Parse.User()
        // if (this.form.company == 'XmyHSNAuOu') {
          user.id = 'pTCrpbtTnJ'
        // } else if (this.form.company == 'LZpb5aKEpp') {
        //   user.id = 'yJ345a2lbx'
        // } else {
        //  alert('Usuario No valido')
        //  return false
        // }
        


        // Datos de destino
        let destination= null
        let work_zone_id = null
        if (this.form.destination === 'TERMINAL 1') {
          destination = {
            "__type": "GeoPoint",
            "latitude": 19.435402,
            "longitude": -99.083627
          }
          work_zone_id = '5H9W8hNnIE'
        } else if (this.form.destination === 'TERMINAL 2') {
          destination = {
            "__type": "GeoPoint",
            "latitude": 19.421879,
            "longitude": -99.077584
          }
          work_zone_id = 'hHERepxKha'
        } else {
          alert('Destino Invalido')
          vue.loading = false
          return false
        }

        

        let params = {
          origin_lat: destination.latitude, 
          origin_lon: destination.longitude,
          destiny_lat: origin_lat,
          destiny_lon: origin_lon,
          type: 2,
          company_id: vue.company.id,
          service_id: vue.form.service,
          work_zone_id: work_zone_id,
          user_id: vue.companyClient.id
        }
        console.log('params', params)
        try {
          let response = await Parse.Cloud.run('costEstimationV2', params)
          console.log('costEstimationV2', response)
          vue.response = response
          if (response.error) {
            vue.price = null
            vue.minutes = null
            vue.kms = null
            vue.zoneName = null
            vue.zonePrice = null
            alert('Error Estimación: ' + response.error)
          }
          if (response.details.cost > 0) {
            // vue.price = response.details.cost
            vue.kms = response.details.kms
            vue.zoneName = null
            vue.minutes = Math.ceil(response.details.seconds/60)
            let query = new Parse.Query('ZonePrice')
            query.include(['zone'])
            let zp = await query.get(response.details.zone_price_id)
            console.log('zp', zp)
            vue.zoneName = zp.get('zone').get('name')
            vue.price = zp.get('price')
            vue.zonePrice = zp
            vue.loading = false
            return true
          } else {
            vue.zonePrice = null
            vue.price = null
            vue.minutes = null
            vue.kms = null
            vue.zoneName = null
            vue.loading = false
            return false
          }
        } catch (error) {
          vue.loading = false
          console.log('Error', error)
          alert('Error cotizando')
          return false
        }
        
          
      },
      async onSubmit(evt) {
        evt.preventDefault()
        let vue = this
        let travel = vue.travel
        let opts = null
        let phoneInt = vue.$refs.telInput.phoneObject.number.international
        let date = new Date(vue.form.date)
        
        try {

          const estFinished = await vue.estimation()
          
          if (!estFinished) {
            alert('Error en estimation')
            return false
          }

          const date = new Date(vue.form.date)
          const phoneInt = vue.$refs.telInput.phoneObject.number.international
          // Datos de origen
          if (!this.form.originAddress) {
            alert('Tiene que elegir una dirección correcta')
            return false
          }

          // Datos de destino
          let destination= null
          if (this.form.destination === 'TERMINAL 1') {
            destination = {
              "__type": "GeoPoint",
              "latitude": 19.4360762,
              "longitude": -99.07190830000002
            }
          } else if (this.form.destination === 'TERMINAL 2') {
            destination = {
              "__type": "GeoPoint",
              "latitude": 19.4182106,
              "longitude": -99.079114
            }
          } else {
            alert('Destino Invalido')
            return false
          }
          vue.loading = true
          const data = {
            companyId: this.company.id,
            serviceId: this.form.service,
            clientName: this.form.name,
            phone: phoneInt,
            email: this.form.email,
            timezone,
            originName: `${this.form.origin} ${this.form.originAddress}`,
            originAddress: this.form.originAddress,
            originLat: this.form.originPosition.latitude,
            originLon: this.form.originPosition.longitude,
            destinyName: this.form.destination,
            destinyLat: destination.latitude,
            destinyLon: destination.longitude,
            date,
            estimatedKms: vue.kms,
            estimatedSec: vue.minutes * 60,
            estimatedCost: vue.price,
            realCost: vue.price,
            originalCost: vue.price,
            zonePriceId: vue.zonePrice.id,
            note: this.form.note,
            zoneName: this.zoneName,
            method: vue.form.method
          }

          let response = null
          try {
            console.log('opts edit', data)
            response = await Parse.Cloud.run('updateTravelPosCallCenter', {
              travelId: travel.id,
              data
            })
          } catch (error) {
            vue.loading = false
            console.log('Error', error)
            alert(error)
            return
          }

          if (!response) {
            vue.loading = false
            alert('Error intentando guardar el viaje')
            return
          }

          const { company, service } = response
          opts = {
            name: vue.form.name,
            phone: phoneInt,
            date: moment(date, timezone).format('DD MMM YYYY HH:mm:SS'),
            email: vue.form.email,
            origin: vue.form.originAddress,
            destination: vue.form.destination,
            company: company.get('name'),
            service: service.get('name'),
            phoneSupport: company.get('phoneSupport'),
            emailSupport: company.get('emailSupport'),
            price: vue.price,
            template: 'd-ab1dd21b150642829f3e6ac49fd911e2'
          }
          console.log('opts', opts)
          await Parse.Cloud.run('reciboReturn', opts)
          vue.loading = false
          alert('Viaje Redondo Guardado')
        } catch (error) {
          vvue.loading = false
          alert('Error intentando guardar el viaje')
          console.log('error', error)
        }

      },
      onReset(evt) {
        if (evt) {
          evt.preventDefault()
        }
        // Reset our form values
        this.price = null
        this.minutes = null
        this.kms = null
        this.zoneName = null
        this.response = null
        this.form.date = null
        this.form.email = ''
        this.form.name = ''
        this.form.origin = ''
        this.form.originPosition = null
        this.form.originAddress = null
        this.form.destination = null
        this.form.company = null
        this.form.checked = []
        this.form.date = null
        this.originAddress = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
      logout () {
        let vue = this
        Parse.User.logOut().then(() => {
          vue.$router.replace('/');
        })
      },
    }
  }
</script>
<style>
.vdatetime-input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
</style>